import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import Navi from "./components/Navi";
import Dashboard from "./components/Dashboard";
import TabelContracte from "./components/TabelContracte";
import TabelPartizi from "./components/TabelPartizi";
import AdaugContract from "./components/AdaugContract";
import AdaugPartida from "./components/AdaugPartida";
import { List } from "react-bootstrap-icons";
import { useAuth } from "./AuthContext";
import Login from "./components/Login";
import AdminUtilizatori from "./components/AdminUtilizatori";
import SituatieExploatare from "./components/SituatieExploatare";
import { useFirestoreData } from "./hooks/useFirestoreData";
import { contractApi } from "./api/contractApi";
import { partidaApi } from "./api/partidaApi"; 
import Swal from "sweetalert2";

const App = () => {
  const { user } = useAuth();
  const [meniuRestrans, setMeniuRestrans] = useState(false);
  const [tema, setTema] = useState(localStorage.getItem("tema") || "light");
  const navigate = useNavigate();
  const { contracte, datePartizi, loading } = useFirestoreData(user); //custom hook pentru datele din Firestore

  const toggleMeniu = () => setMeniuRestrans(!meniuRestrans);

  const toggleTema = () => {
    const nouaTema = tema === "light" ? "dark" : "light";
    setTema(nouaTema);
    localStorage.setItem("tema", nouaTema);
    console.log(`Tema schimbată la: ${nouaTema}`);
  };

  // Gestionare Tema și Stiluri Globale
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", tema);
    if (tema === "dark") {
      document.body.classList.add("bg-dark", "text-light");
    } else {
      document.body.classList.remove("bg-dark", "text-light");
    }
  }, [tema]);



  const handleAdaugPartida = async (partida) => {
    try {
      await partidaApi.add(partida, user);
      Swal.fire("Succes", "Partida a fost adăugată!", "success");
      navigate("/TabelPartizi");
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  const handleStergePartida = async (partida) => {
    if (partida.stare === "contractat") {
      return Swal.fire(
        "Acțiune interzisă",
        "Nu poți șterge o partidă contractată!",
        "error",
      );
    }

    const confirmare = await Swal.fire({
      title: `Ștergi partida ${partida.fond}?`,
      text: "Acțiunea este ireversibilă!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      background: tema === "dark" ? "#2b3035" : "#fff",
      color: tema === "dark" ? "#fff" : "#000",
    });

    if (confirmare.isConfirmed) {
      try {
        await partidaApi.delete(partida.id);
        Swal.fire("Șters!", "Partida a fost eliminată.", "success");
      } catch (err) {
        Swal.fire("Eroare", err.message, "error");
      }
    }
  };

  const handleEditeazaPartida = async (id, date) => {
    try {
      await partidaApi.update(id, date, user);
      Swal.fire("Succes", "Partidă actualizată!", "success");
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  const handleAdaugContract = async (dateContract) => {
    try {
      await contractApi.create(dateContract, user);
      Swal.fire("Succes", "Contract creat cu succes!", "success");
      navigate("/prestari");
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  const handleEditeazaContract = async (id, dateNoi) => {
    try {
      await contractApi.edit(id, dateNoi);
      Swal.fire("Succes", "Contract actualizat!", "success");
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  if (!user) return <Login />;
  if (loading)
    return <div className="p-5 text-center">Se încarcă datele...</div>;

  return (
    <Container fluid className="p-0">
      <Row
        className="g-0 flex-nowrap"
        style={{ minHeight: "100vh", width: "100%" }}
      >
        {/* SIDEBAR */}
        <Col
          className="min-vh-100 shadow-lg transition-all"
          style={{
            backgroundColor: tema === "dark" ? "#0f172a" : "#ffffff",
            borderRight: `1px solid ${tema === "dark" ? "#1e293b" : "#dee2e6"}`,
            transition: "all 0.3s ease",
            width: meniuRestrans ? "75px" : "270px",
            padding: 0,
            zIndex: 1000,
          }}
        >
          <div
            className={`d-flex align-items-center mt-3 mb-4 px-3 ${
              meniuRestrans
                ? "justify-content-center"
                : "justify-content-between"
            }`}
          >
            {!meniuRestrans && (
              <h4
                className="fw-bold mb-0 px-2 text-center"
                style={{
                  fontSize: "1rem",
                  color: tema === "dark" ? "#60a5fa" : "#198754",
                  letterSpacing: "0.5px",
                }}
              >
                SITUAȚIA EXPLOATĂRII
              </h4>
            )}

            <Button
              variant={tema === "dark" ? "outline-info" : "outline-success"}
              onClick={toggleMeniu}
              className="border-0 p-2 rounded-circle"
              style={{
                backgroundColor: "transparent",
                color: tema === "dark" ? "#60a5fa" : "#198754",
              }}
            >
              <List size={22} />
            </Button>
          </div>

          <Navi
            tema={tema}
            toggleTema={toggleTema}
            restrans={meniuRestrans}
            laToggle={toggleMeniu}
          />

        
        </Col>

        {/* MAIN CONTENT */}
        <Col
          className="d-flex flex-column"
          style={{
            flex: "1 1 auto",
            backgroundColor: tema === "dark" ? "#2323239b" : "#e1e1e1ba",
            minWidth: "0",
          }}
        >
          <Routes>
            <Route
              path="/"
              element={
                <Dashboard date={contracte} tema={tema} partizi={datePartizi} />
              }
            />
            <Route
              path="/situatie-exploatare"
              element={
                <SituatieExploatare toatePartizile={datePartizi} tema={tema} />
              }
            />
            <Route
              path="/adaugPartida"
              element={
                <AdaugPartida tema={tema} transmit={handleAdaugPartida} />
              }
            />
            <Route
              path="/prestari"
              element={
                <TabelContracte
                  titlu="Contracte Silvice"
                  date={contracte}
                  toatePartizile={datePartizi}
                  laEditare={handleEditeazaContract}
                  laEditarePartida={handleEditeazaPartida}
                />
              }
            />
            <Route
              path="/adaug"
              element={
                <AdaugContract
                  transmit={handleAdaugContract}
                  tema={tema}
                  partizi={datePartizi}
                  user={user}
                />
              }
            />
            <Route
              path="/admin-utilizatori"
              element={
                user?.rol === "administrator" ? (
                  <AdminUtilizatori />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/TabelPartizi"
              element={
                <TabelPartizi
                  titlu="Gestiune Partizi"
                  date={datePartizi}
                  laStergere={handleStergePartida}
                  laEditare={handleEditeazaPartida}
                  tema={tema}
                  user={user}
                />
              }
            />
          </Routes>
        </Col>
      </Row>
    </Container>
  );
};

export default App;
